export default __webpack_public_path__ + "static/media/weenix.4d931e50.png";